 

       export const predictionParams = (item)=>{
        
        
            const prDate = item.preferDateFrom && (new Date(item.preferDateFrom).getTime() > new Date().getTime() ) ? new Date(item.preferDateFrom) : new Date();

            let learnYear = prDate.getMonth() > 4 ? prDate.getFullYear() :  prDate.getFullYear() - 1
            
            const birthDateCorrect = {
                year: new Date(item.child.birthDate).getFullYear(),
                month: new Date(item.child.birthDate).getMonth()
            };

            const getFullYear = (learnYear, birthDateObj) =>{

                let correctionYear = birthDateObj.month > 8 ? 1 : 0;

                let result = learnYear - birthDateObj.year - correctionYear;

                if (result === 1 && (birthDateObj.month < 3 || birthDateObj.month > 8 ) ) result = 1.5;

                if (result === 0 && (birthDateObj.month < 3 || birthDateObj.month > 8 ) ) result = 0.5;


                return result;

            }; 



            let ageGroup = getFullYear(learnYear, birthDateCorrect);

            if(ageGroup < 1) {
                learnYear += (1-parseInt(ageGroup))
                ageGroup += (1-parseInt(ageGroup))
            }

            const corregAge = item.youngerGroup ? -1 : 0


            const age_category = {
                learnYear: learnYear,
                ageGroup: ageGroup,
                corregAge: corregAge
            };

            let ageCategoryType = [];

            ageCategoryType[age_category.learnYear] =  age_category.ageGroup < 8 ? age_category.ageGroup+age_category.corregAge+'-'+((age_category.ageGroup+age_category.corregAge+1)|0)+' ': 'перевищує вісім';
            ageCategoryType[age_category.learnYear] +=  age_category.ageGroup > 3 ? 'років':'роки';

            ageCategoryType[age_category.learnYear+1] =  age_category.ageGroup+1 < 8 ? ((age_category.ageGroup+age_category.corregAge+1)|0) +'-'+((age_category.ageGroup+age_category.corregAge+2)|0)+' ': 'перевищує вісім';
            ageCategoryType[age_category.learnYear+1] +=  age_category.ageGroup+1 > 3 ? 'років':'роки';



            return ({ age: ageGroup + corregAge, ageCategory: age_category, ageCategoryType});

    }
